import type { ArianeRoute } from '~/types/arianeRoute'

export const useBreadcrumbSchema = ({
  arianeRoute,
}: {
  arianeRoute: MaybeRef<ArianeRoute[]>
}) => {
  const route = useRoute()
  const runtimeConfig = useRuntimeConfig()
  const { baseUrl } = runtimeConfig.public

  return computed(() => {
    const rawArianeRoute = unref(arianeRoute)
    const itemListElement = rawArianeRoute.map((item, index) => {
      const itemRoute = item.route ? item.route : route.path
      return {
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@id': `${baseUrl}${itemRoute}`,
          name: item.title,
        },
      }
    })

    return {
      type: 'application/ld+json',
      json: {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement,
      },
    }
  })
}
